<template>
  <my-modal
    v-model:visible="visibleModel"
    title="Mass message илгээх"
    save-text="Илгээх"
    :saving="loading"
    @save="handleSend"
  >
    <my-input label="Эмчилгээний он, сар" v-if="currentTreatment" readonly v-model="currentTreatment.treatmentAt" />
    <my-select-list v-model="treatmentDay" label="Эмчилгээний өдөр, цаг" :options="treatmentDays" required></my-select-list>
    <my-input label="Илгээх утга" type="textarea" :modelValue="smsText" readonly rows="2"></my-input>
    <my-input label="Өмнө явуулсан дугааруудад дахин илгээх" type="checkbox" v-model="resend"></my-input>
  </my-modal>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false }
  },
  data () {
    return {
      currentTreatment: null,
      currentSmsText: '',
      treatmentDay: null,
      loading: false,
      resend: false
    }
  },
  computed: {
    visibleModel: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    treatmentDays () {
      return this.currentTreatment && this.currentTreatment.treatmentDays ? this.currentTreatment.treatmentDays.split(',').map(c => { return c.trim() }) : []
    },
    smsText () {
      if (this.currentTreatment && this.currentSmsText && this.treatmentDay) {
        const month = this.currentTreatment.treatmentAt.split('-')[1]
        const day = this.treatmentDay.split(' ')[0]
        const time = this.treatmentDay.split(' ')[1]
        return this.currentSmsText.replace('{month}', month).replace('{day}', day).replace('{time}', time)
      } else {
        return this.currentSmsText
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.handleRefresh()
      }
    }
  },
  methods: {
    handleRefresh () {
      this.currentTreatment = null
      this.currentSmsText = ''
      this.treatmentDay = null
      this.loading = false
      this.getCurrentTreatment()
    },
    async handleSend () {
      try {
        if (!this.treatmentDay) {
          this.customError('Эмчилгээний өдөр цагийг сонгоно уу.')
        }
        if (!this.currentSmsText) {
          this.customError('Илгээх утга буруу байна.')
        }
        this.loading = true
        await this.axios.post('contracts/sms/mass', {
          id: this.currentTreatment.id,
          treatmentDay: this.treatmentDay,
          text: this.smsText,
          resend: this.resend
        })
        this.showToast('Амжилттай илгээж дууслаа.')
        this.visibleModel = false
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async getCurrentTreatment () {
      try {
        this.currentSmsText = (await this.axios.get('lookups/current/sms/text')).data
        this.currentTreatment = (await this.axios.get('lookups/current/treatment')).data
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
